function now() {
    return Date.now() / 1000 | 0;
}

if (!window.$requestUtil) {
    window.$requestUtil = {
        sstm: now(),
        request_id: 0,
        uuid: $util.uuidv4(),
        infoReported: false,
    };
}

export const uuid = $requestUtil.uuid;
export const sstm = $requestUtil.sstm;

export const logger = (str) => {
    // console.log(str);
    if(window.nativeConsole && typeof nativeConsole.log === 'function') {
        nativeConsole.log(str);
    }
    if(typeof window.__logger === 'function') {
        window.__logger(str);
    } else if(Array.isArray(window.__logs)) {
        __logs.push([ new Date().toLocaleString(), str ]);
    }
}

const notifySessionExpire = () => {
    $app.send({"action":"sso_validation_failed"});
}

class Requester {
    constructor() {
        this.headers = {};
        this.baseUrlOverride = "";
        this.paramsPreprocessors = [];
    }

    getBase() {
        let base = `${document.location.origin}/tws.proxy`;
        try {
            if(PROCESS_ENDPOINT !== undefined) {
                base = PROCESS_ENDPOINT;
            }
        } catch(e) {}
        return (this.baseUrlOverride || base);
    }

    formatUrl(url) {
        if(url.indexOf('http') === 0) {
            return url;
        } else {
            return this.getBase() + '/' + url;
        }
    }

    addParamsPreprocessor(fn) {
        this.paramsPreprocessors.push(fn);
        return () => {
            this.paramsPreprocessors = this.paramsPreprocessors.filter(p => p !== fn);
        }
    }

    formatParams(params) {
        const XYZAB_cookie = $util.cookie('XYZAB');
        // const USERID_cookie = $util.cookie('USERID');

        const validateCookie = (cookieVal) => {
            if(
                cookieVal !== null &&
                cookieVal !== undefined &&
                (''+cookieVal).toLowerCase() !== 'null' &&
                (''+cookieVal).toLowerCase() !== 'undefined' &&
                /^[a-z0-9]+$/i.exec(cookieVal)
            ) {
                return true;
            }
            return false;
        }

        let headers = {
            'Content-Type': 'application/json; charset=utf-8',
            'x-session-id': $requestUtil.uuid,
            'x-request-id': $requestUtil.request_id++,
            "X-SERVICE": $build.platform === "web" ? "AM.LOGIN" : "WEB_APP_ACTION",
            "x-embedded-in": $build.platform,
            "X-WA-VERSION": $build.rev + "/" + $build.date
        };

        if(validateCookie(XYZAB_cookie)) {
            headers['X-XYZAB'] = XYZAB_cookie;
        }

        // if(validateCookie(USERID_cookie)) {
        //     headers['X-USERID'] = USERID_cookie;
        // }

        let paramsDefault = {
            credentials: 'include',
            headers,
            ...params
        };

        return this.paramsPreprocessors.reduce((acc, v) => { acc = v(acc); return acc; }, paramsDefault);
    }

    overrideBase(newBase) {
        this.baseUrlOverride = newBase;
    }

    request(url, params) {
        logger(`WA > requesting ${url} with params ${JSON.stringify(params)}`);

        return fetch(this.formatUrl(url), this.formatParams(params))
            .then(v => {
                if(v.clone) {
                    var cloneResponse = v.clone();
                    if(cloneResponse && cloneResponse.status && cloneResponse.status.toString() === '401') {
                        notifySessionExpire();
                        return Promise.reject(new Error("Session expired"));
                    }
                    if(!cloneResponse.ok) {
                        cloneResponse.text().then(text => {
                            logger(`WA > ${url} FAILED with response ${text} statusText ${cloneResponse.statusText} statusCode ${cloneResponse.status}`);
                        }).catch(e => {
                            logger(`WA > ${url} FAILED with response error message ${e ? e.message : 'Unknown'} statusText ${cloneResponse.statusText} statusCode ${cloneResponse.status}`);
                        })
                    } else {
                        cloneResponse.text().then(text => {
                            logger(`WA > ${url} SUCCESS with response ${text} statusText ${cloneResponse.statusText} statusCode ${cloneResponse.status}`);
                        }).catch(e => {
                            logger(`WA > ${url} FAILED with response error message ${e ? e.message : 'Unknown'} statusText ${cloneResponse.statusText} statusCode ${cloneResponse.status}`);
                        })
                    }
                } else {
                    logger(`WA > ${url} SUCCESS with response ${v} statusText ${v && v.statusText} statusCode ${v && v.status}`);
                }
                return v;
            })
            .catch(e => {
                logger(`WA > ${url} FAILED with response ${e ? e.message : 'Unknown'}`);
                return e;
            })
    }

    reportTelemetry(payload, nonAuthUsername = 'unknown', infoParams = {}) {
        const platform = $build?.platform;
        const info = $requestUtil.infoReported ?
            undefined :
            {
                prod: $build?.env == 'production' ? 1 : 0,
                ...infoParams
            };

        const webTel = platform === 'web' || platform === 'desktop';
        const sessionData = {
            wa_session: uuid,
            sstm,
            t: now() - sstm
        }
        let data = {...payload, ...sessionData};
        if(!webTel) {
            $app.send({action: 'web_app_telemetry', data});
        } else {
            $requestUtil.infoReported = true;
            const body = {
                sstm,
                info,
                data
            };
            return this.request('telemetry/authAdd', {
                method: 'POST',
                body: JSON.stringify(body)
            })
            .then(r => {
                if(!r.ok && ["401", "400"].includes(r.status.toString())) {
                    return this.request('telemetry/noAuthAdd', {
                        method: 'POST',
                        body: JSON.stringify({
                            user: nonAuthUsername,
                            ...body
                        })
                    })
                    .then(r => {
                        if(r.ok) {
                            return r.json();
                        }
                        throw "Failed non auth telemetry"
                    })
                } else if(!r.ok) {
                    throw "Failed auth telemetry"
                } else {
                    return r.json()
                }

            })
            .catch(v => {
                console.log(v);
            })
        }
    }

}

const instance = new Requester();

export const ibotFeedback = (feedback_context, feedback_originator, feedback) => {
    return instance.request('faq/feedback', {
        method: 'POST',
        body: JSON.stringify({
            "@type": "feedback",
            "feedback": feedback || 1,
            feedback_context,
            feedback_originator
        })
    })
}

export default instance;
